import MoneyBagIcon from '@/assets/icons/money-bag.svg'
import SoundIcon from '@/assets/icons/sound.svg'
import WalletIcon from '@/assets/icons/wallet.svg'
import { cn } from '@/core/lib/utils/cn'
import { getTranslations } from 'next-intl/server'

type Props = {
  className?: string
}
export const Center: React.FC<Props> = async ({ className }) => {
  const t = await getTranslations()

  return (
    <div className={cn('sm:ms-4 md:m-0', className)}>
      <h1 className='mb-8 text-2xl font-medium'>
        {t('brand.name')} {t('help.center')}
      </h1>

      <article className='mb-16 leading-7'>
        <p className='my-2'>
          <span className='me-2 text-xl font-semibold'>
            {t('help.welcome')} {t('brand.name')} {t('help.center')}!
          </span>
          {t('help.desc')}
        </p>
        <p className='my-2'>
          <strong>{t('help.getStarted')}:</strong> {t('help.learnSignup')}
        </p>
        <p className='my-2'>
          <strong>{t('help.account')}:</strong> {t('help.manageDetails')}
        </p>
        <p className='my-2'>
          <strong>{t('help.rideIssues')}:</strong>{' '}
          {t('help.encounteredAProblem')}
        </p>
        <p className='my-2'>
          <strong>{t('help.safety')}:</strong> {t('help.discoverTheMeasure')}
        </p>
        <p className='my-2'>
          <strong>{t('help.faq')}:</strong> {t('help.haveQ')}
        </p>
      </article>

      <ul className='mb-14'>
        <li className='mb-12 flex'>
          <div className='relative mt-3 h-fit'>
            <span className='bg-red absolute bottom-2 -z-10 h-10 w-10 origin-bottom -rotate-12 rounded' />
            <SoundIcon className='bg-grey-2 z-0 h-10 w-10 rounded p-2' />
          </div>
          <div className='ms-6'>
            <h2 className='mb-4 font-semibold'>{t('features.fast.title')}</h2>
            <p>{t('features.fast.desc')}</p>
          </div>
        </li>

        <li className='mb-12 flex'>
          <div className='relative mt-3 h-fit'>
            <span className='bg-sky-blue absolute bottom-2 -z-10 h-10 w-10 origin-bottom -rotate-12 rounded' />
            <WalletIcon className='bg-grey-2 z-0 h-10 w-10 rounded p-2' />
          </div>
          <div className='ms-6'>
            <h2 className='mb-4 font-semibold'>{t('features.wallet.title')}</h2>
            <p>{t('features.wallet.desc')}</p>
          </div>
        </li>

        <li className='mb-12 flex'>
          <div className='relative mt-3 h-fit'>
            <span className='bg-navy absolute bottom-2 -z-10 h-10 w-10 origin-bottom -rotate-12 rounded' />
            <MoneyBagIcon className='bg-grey-2 z-0 h-10 w-10 rounded p-2' />
          </div>
          <div className='ms-6'>
            <h2 className='mb-4 font-semibold'>{t('features.bank.title')}</h2>
            <p>{t('features.bank.desc')}</p>
          </div>
        </li>
      </ul>
    </div>
  )
}
